import { register } from '@onpace/onspace-core/components/translations'

register({
  "en": {
    "onspace": {
      "forms": {
        "definition": {
          "error": {
            "unknown": "The form could not be loaded because an unknown error occurred."
          },
          "navigation": {
            "results": "Results",
            "submit": "Submit"
          },
          "result": {
            "average": "Average: %{average}"
          }
        }
      }
    }
  }
})
